(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-page]');
    if (!root) return;

    var sectionId = root.getAttribute('data-section-id') || '';
    var updatingText = root.getAttribute('data-updating-text') || '';

    var form = root.querySelector('.js-cart-page-form');
    if (!form) return;

    var statusEl = root.querySelector('.js-cart-page-status');
    var subtotalEl = root.querySelector('.js-cart-subtotal');
    var countEl = root.querySelector('.js-cart-page-count');
    var debounceTimers = new WeakMap();
    var activeRequest = null;

    function setUpdating(isUpdating) {
      form.classList.toggle('is-updating', isUpdating);
      if (statusEl) {
        statusEl.textContent = isUpdating ? updatingText : '';
      }
    }

    function refreshCartSection() {
      var sectionUrl = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);
      return fetch(sectionUrl, { credentials: 'same-origin' })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var nextInner = doc.querySelector('.js-cart-page-inner');
          var currentInner = root.querySelector('.js-cart-page-inner');
          if (nextInner && currentInner) {
            currentInner.innerHTML = nextInner.innerHTML;
            bindQuantityInputs();
          } else {
            window.location.reload();
          }
        });
    }

    function changeLineQuantity(lineKey, quantity, lineEl) {
      if (!lineKey) return Promise.resolve();

      if (activeRequest) {
        activeRequest.abort();
      }

      var controller = new AbortController();
      activeRequest = controller;

      setUpdating(true);
      if (lineEl) {
        lineEl.classList.add('is-updating');
      }

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        signal: controller.signal,
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Cart update failed');
          }
          return response.json();
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          return refreshCartSection();
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          window.location.reload();
        })
        .finally(function () {
          activeRequest = null;
          setUpdating(false);
          if (lineEl) {
            lineEl.classList.remove('is-updating');
          }
        });
    }

    function bindQuantityInputs() {
      form = root.querySelector('.js-cart-page-form');
      if (!form) return;

      statusEl = root.querySelector('.js-cart-page-status');
      subtotalEl = root.querySelector('.js-cart-subtotal');
      countEl = root.querySelector('.js-cart-page-count');

      form.querySelectorAll('.js-cart-qty-input').forEach(function (input) {
        if (input.dataset.bound === 'true') return;
        input.dataset.bound = 'true';

        function scheduleUpdate() {
          var lineKey = input.getAttribute('data-line-key');
          var lineEl = input.closest('.js-cart-page-item');
          var qty = parseInt(input.value, 10);

          if (isNaN(qty) || qty < 0) return;

          var previous = parseInt(input.getAttribute('data-initial-qty'), 10);
          if (!isNaN(previous) && previous === qty) return;

          if (debounceTimers.has(input)) {
            clearTimeout(debounceTimers.get(input));
          }

          debounceTimers.set(
            input,
            setTimeout(function () {
              changeLineQuantity(lineKey, qty, lineEl);
            }, 450)
          );
        }

        input.addEventListener('change', scheduleUpdate);
        input.addEventListener('input', scheduleUpdate);
      });
    }

    bindQuantityInputs();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["efficiency-quality"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const wrappers = document.querySelectorAll('.efficiency-quality__slider-wrapper');
    
    wrappers.forEach(wrapper => {
      const viewport = wrapper.querySelector('.efficiency-quality__viewport');
      const prevBtn = wrapper.querySelector('.efficiency-quality__arrow--prev');
      const nextBtn = wrapper.querySelector('.efficiency-quality__arrow--next');
      
      if (!viewport || !prevBtn || !nextBtn) return;
      
      const scrollCards = () => {
        const firstCard = viewport.querySelector('.efficiency-quality__card');
        const gap = 24; 
        if (!firstCard) return 400; 
        return firstCard.offsetWidth + gap;
      };

      prevBtn.addEventListener('click', () => {
        viewport.scrollBy({ left: -scrollCards(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        viewport.scrollBy({ left: scrollCards(), behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openAccordionForHash(root, hash) {
      if (!hash || hash.charAt(0) !== '#') return;
      var target = root.querySelector(hash);
      if (!target) return;
      var details = target.querySelector('details');
      if (details) details.open = true;
    }

    function setActiveForHash(root, hash) {
      root.querySelectorAll('.faq-page__nav-link').forEach(function (l) {
        l.classList.toggle('is-active', hash && l.getAttribute('href') === hash);
      });
    }

    function syncAllFromHash() {
      var hash = window.location.hash;
      document.querySelectorAll('.faq-page').forEach(function (root) {
        if (hash) openAccordionForHash(root, hash);
        setActiveForHash(root, hash || '');
      });
    }

    document.querySelectorAll('.faq-page').forEach(function (root) {
      var links = root.querySelectorAll('.faq-page__nav-link');
      links.forEach(function (link) {
        link.addEventListener('click', function () {
          var href = link.getAttribute('href');
          links.forEach(function (l) {
            l.classList.toggle('is-active', l === link);
          });
          requestAnimationFrame(function () {
            openAccordionForHash(root, href);
          });
        });
      });
    });

    window.addEventListener('hashchange', syncAllFromHash);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAllFromHash);
    } else {
      syncAllFromHash();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-cards-slider"] && !Shopify.designMode) return;
  try {
    
  function featuredCardsSliderScrollToEnd() {
    document.querySelectorAll('.featured-cards-slider__viewport').forEach(function (root) {
      root.scrollLeft = root.scrollWidth - root.clientWidth;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', featuredCardsSliderScrollToEnd);
  } else {
    featuredCardsSliderScrollToEnd();
  }

  window.addEventListener('resize', featuredCardsSliderScrollToEnd);
  document.addEventListener('shopify:section:load', featuredCardsSliderScrollToEnd);

  requestAnimationFrame(function () {
    requestAnimationFrame(featuredCardsSliderScrollToEnd);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var DEFAULT_OPEN_LABEL = 'Open menu';
    var DEFAULT_CLOSE_LABEL = 'Close menu';

    function formatCartAria(template, count) {
      if (!template) return '';
      return template.split('__COUNT__').join(String(count));
    }

    function updateHeaderCartBadge(itemCount) {
      var count = Math.max(0, parseInt(itemCount, 10) || 0);
      var display = count > 99 ? '99+' : String(count);

      document.querySelectorAll('.js-tribex-header-cart').forEach(function (link) {
        var badge = link.querySelector('.js-tribex-header-cart-count');
        if (badge) {
          if (count > 0) {
            badge.textContent = display;
            badge.removeAttribute('hidden');
          } else {
            badge.setAttribute('hidden', '');
          }
        }

        var ariaLabel = '';
        if (count === 0) {
          ariaLabel = link.getAttribute('data-aria-empty') || '';
        } else if (count === 1) {
          ariaLabel = formatCartAria(link.getAttribute('data-aria-one'), 1);
        } else {
          ariaLabel = formatCartAria(link.getAttribute('data-aria-other'), count);
        }

        if (ariaLabel) {
          link.setAttribute('aria-label', ariaLabel);
        }
      });
    }

    document.addEventListener('cart:updated', function (event) {
      var cart = event.detail && event.detail.cart;
      if (cart && typeof cart.item_count === 'number') {
        updateHeaderCartBadge(cart.item_count);
      }
    });

    function getMenuLabels(header) {
      return {
        open: header.getAttribute('data-menu-open-label') || DEFAULT_OPEN_LABEL,
        close: header.getAttribute('data-menu-close-label') || DEFAULT_CLOSE_LABEL
      };
    }

    var tribexHeaderScrollY = 0;

    function unlockHeaderScroll() {
      if (!document.body.classList.contains('tribex-header-menu-open')) return;

      var scrollY = tribexHeaderScrollY;
      document.documentElement.classList.remove('tribex-header-menu-open');
      document.body.classList.remove('tribex-header-menu-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
    }

    function setHeaderOpen(header, isOpen) {
      if (!header) return;

      var toggle = header.querySelector('.js-tribex-header-toggle');
      var panel = header.querySelector('.js-tribex-header-panel');
      if (!toggle || !panel) return;

      var labels = getMenuLabels(header);

      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', isOpen ? labels.close : labels.open);
      panel.classList.toggle('is-open', isOpen);
      header.classList.toggle('is-menu-open', isOpen);

      if (isOpen) {
        tribexHeaderScrollY = window.scrollY || window.pageYOffset || 0;
        panel.removeAttribute('hidden');
        document.documentElement.classList.add('tribex-header-menu-open');
        document.body.classList.add('tribex-header-menu-open');
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + tribexHeaderScrollY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      } else {
        panel.setAttribute('hidden', '');
        unlockHeaderScroll();
      }
    }

    function closeAllHeaders() {
      document.querySelectorAll('[data-tribex-header]').forEach(function (header) {
        setHeaderOpen(header, false);
      });
    }

    function bindTribexHeader(header) {
      if (!header || header.getAttribute('data-tribex-header-bound') === 'true') return;

      var toggle = header.querySelector('.js-tribex-header-toggle');
      var panel = header.querySelector('.js-tribex-header-panel');
      if (!toggle || !panel) return;

      header.setAttribute('data-tribex-header-bound', 'true');

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        setHeaderOpen(header, !expanded);
      });

      panel.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setHeaderOpen(header, false);
        });
      });
    }

    function initTribexHeaders() {
      document.querySelectorAll('[data-tribex-header]').forEach(bindTribexHeader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTribexHeaders);
    } else {
      initTribexHeaders();
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllHeaders();
    });

    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 901px)').matches) closeAllHeaders();
    });

    window.addEventListener('pageshow', function () {
      closeAllHeaders();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        closeAllHeaders();
      }
    });

    document.addEventListener('shopify:section:load', function (event) {
      var header = event.target.querySelector('[data-tribex-header]');
      if (header) {
        header.removeAttribute('data-tribex-header-bound');
        bindTribexHeader(header);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-benefits-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tribexIngredientsDocCollapseBound = false;

    function syncIngredientPageWidths(section) {
      var viewport = section.querySelector('.js-ingredients-slider-viewport');
      if (!viewport) return;
      var w = viewport.offsetWidth;
      if (w <= 0) return;
      section.querySelectorAll('.ingredients-benefits-list__page').forEach(function (page) {
        page.style.flexBasis = w + 'px';
        page.style.width = w + 'px';
        page.style.maxWidth = w + 'px';
      });
    }

    function setActiveIngredientDot(section, pageIndex) {
      section.querySelectorAll('.js-ingredients-slider-dot').forEach(function (dot, i) {
        var active = i === pageIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        dot.setAttribute('tabindex', active ? '0' : '-1');
      });

      var pageCountNav = parseInt(section.getAttribute('data-ingredient-pages') || '1', 10);
      var prevBtn = section.querySelector('.js-ingredients-slider-prev');
      var nextBtn = section.querySelector('.js-ingredients-slider-next');
      if (prevBtn) {
        var prevDisabled = pageIndex <= 0;
        prevBtn.disabled = prevDisabled;
        prevBtn.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false');
      }
      if (nextBtn) {
        var nextDisabled = pageIndex >= pageCountNav - 1;
        nextBtn.disabled = nextDisabled;
        nextBtn.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false');
      }
    }

    function bindIngredientsSlider(section) {
      if (!section) return;
      if (section.getAttribute('data-ingredients-slider-bound') === 'true') return;
      var viewport = section.querySelector('.js-ingredients-slider-viewport');
      var dots = section.querySelectorAll('.js-ingredients-slider-dot');
      if (!viewport) return;

      section.setAttribute('data-ingredients-slider-bound', 'true');

      var pageCount = parseInt(section.getAttribute('data-ingredient-pages') || '1', 10);
      if (pageCount < 2) {
        syncIngredientPageWidths(section);
        return;
      }

      function goToPage(index) {
        if (index < 0 || index >= pageCount) return;
        var w = viewport.offsetWidth;
        if (w <= 0) return;
        viewport.scrollTo({ left: index * w, behavior: 'smooth' });
        setActiveIngredientDot(section, index);
      }

      function readScrollPage() {
        var w = viewport.offsetWidth;
        if (w <= 0) return;
        var idx = Math.round(viewport.scrollLeft / w);
        if (idx < 0) idx = 0;
        if (idx >= pageCount) idx = pageCount - 1;
        setActiveIngredientDot(section, idx);
      }

      syncIngredientPageWidths(section);

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var p = parseInt(dot.getAttribute('data-page') || '0', 10);
          goToPage(p);
        });
      });

      var prevBtn = section.querySelector('.js-ingredients-slider-prev');
      var nextBtn = section.querySelector('.js-ingredients-slider-next');
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          var w = viewport.offsetWidth;
          if (w <= 0) return;
          var idx = Math.round(viewport.scrollLeft / w);
          goToPage(idx - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var w = viewport.offsetWidth;
          if (w <= 0) return;
          var idx = Math.round(viewport.scrollLeft / w);
          goToPage(idx + 1);
        });
      }

      var scrollRaf = 0;
      viewport.addEventListener('scroll', function () {
        if (scrollRaf) window.cancelAnimationFrame(scrollRaf);
        scrollRaf = window.requestAnimationFrame(function () {
          scrollRaf = 0;
          readScrollPage();
        });
      });

      var resizeTimer = 0;
      window.addEventListener('resize', function () {
        if (resizeTimer) window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          resizeTimer = 0;
          syncIngredientPageWidths(section);
          var w = viewport.offsetWidth;
          if (w <= 0) return;
          var idx = Math.round(viewport.scrollLeft / w);
          idx = Math.max(0, Math.min(idx, pageCount - 1));
          viewport.scrollLeft = idx * w;
        }, 120);
      });

      readScrollPage();
    }

    function collapseDetailBreaks(detail) {
      if (!detail) return;
      if (detail.getAttribute('data-detail-mode') === 'structured') return;
      var html = detail.innerHTML;
      var prev = '';
      while (html !== prev) {
        prev = html;
        html = html.replace(/(<br\s*\/?>\s*){2,}/gi, '<br>');
      }
      detail.innerHTML = html;
    }

    function formatDetailHeadings(card) {
      var detail = card.querySelector('.ingredients-benefits-list__detail');
      if (!detail || detail.dataset.formatted === 'true') return;
      if (detail.getAttribute('data-detail-mode') === 'structured') return;

      var parts = detail.innerHTML.split(/<br\s*\/?>/gi);
      var result = parts.map(function (part) {
        var text = part.replace(/<[^>]+>/g, '').trim();
        if (text.length > 0 && text === text.toUpperCase() && /[A-Z]/.test(text)) {
          return '<strong class="ingredients-benefits-list__detail-heading">' + text + '</strong>';
        }
        return part;
      });
      detail.innerHTML = result
        .filter(function (chunk) {
          return String(chunk).replace(/&nbsp;/g, ' ').replace(/\s/g, '').length > 0;
        })
        .join('');
      detail.dataset.formatted = 'true';
      collapseDetailBreaks(detail);
    }

    function clearAutoCollapseTimer(section) {
      if (!section) return;
      var raw = section.getAttribute('data-ib-auto-collapse-timer');
      if (!raw) return;
      var tid = parseInt(raw, 10);
      if (!isNaN(tid)) window.clearTimeout(tid);
      section.removeAttribute('data-ib-auto-collapse-timer');
    }

    function collapseAllCardsImmediate(page) {
      page.querySelectorAll('.js-ingredient-card').forEach(function (c) {
        c.classList.remove('is-expanded', 'is-row-hidden', 'is-rolling-shut');
        c.removeAttribute('data-roll-close-busy');
      });
    }

    function collapseExpandedCardAnimated(page, onDone) {
      var card = page.querySelector('.js-ingredient-card.is-expanded');
      if (!card) {
        if (onDone) onDone();
        return;
      }
      if (card.getAttribute('data-roll-close-busy') === '1') {
        collapseAllCardsImmediate(page);
        if (onDone) onDone();
        return;
      }
      card.setAttribute('data-roll-close-busy', '1');
      card.classList.add('is-rolling-shut');

      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;
        card.classList.remove('is-rolling-shut');
        card.removeAttribute('data-roll-close-busy');
        collapseAllCardsImmediate(page);
        if (onDone) onDone();
      }

      var fallbackMs = 480;
      var tid = window.setTimeout(finish, fallbackMs);

      card.addEventListener(
        'animationend',
        function onAnim(e) {
          if (e.target !== card) return;
          if (String(e.animationName || '').indexOf('ingredient-roll-shut') === -1) return;
          window.clearTimeout(tid);
          card.removeEventListener('animationend', onAnim);
          finish();
        },
        false
      );
    }

    function getPageGridColumns(page) {
      if (!page || !window.getComputedStyle) return 3;
      var tpl = window.getComputedStyle(page).gridTemplateColumns || '';
      if (!tpl || tpl === 'none') return 3;
      var cols = tpl
        .trim()
        .split(/\s+/)
        .filter(function (token) {
          return token && token !== 'none';
        }).length;
      return cols > 0 ? cols : 3;
    }

    function getCardRow(pos, cols) {
      return Math.floor(pos / cols);
    }

    function expandCard(card, page) {
      var section = page.closest('.ingredients-benefits-list');
      clearAutoCollapseTimer(section);

      var pos = parseInt(card.getAttribute('data-card-pos') || '0', 10);
      var cols = getPageGridColumns(page);
      var row = getCardRow(pos, cols);

      collapseAllCardsImmediate(page);

      card.classList.remove('is-rolling-shut');
      card.removeAttribute('data-roll-close-busy');
      card.classList.add('is-expanded');
      formatDetailHeadings(card);

      page.querySelectorAll('.js-ingredient-card').forEach(function (sibling) {
        if (sibling === card) return;
        var sibPos = parseInt(sibling.getAttribute('data-card-pos') || '0', 10);
        var sibRow = getCardRow(sibPos, cols);
        if (sibRow === row) {
          sibling.classList.add('is-row-hidden');
        }
      });
    }

    function bindCardExpansion(section) {
      if (!section) return;
      if (section.getAttribute('data-card-expansion-bound') === 'true') return;
      section.setAttribute('data-card-expansion-bound', 'true');

      section.querySelectorAll('.ingredients-benefits-list__page').forEach(function (page) {
        page.querySelectorAll('.js-ingredient-card').forEach(function (card) {
          card.addEventListener('click', function (e) {
            var closeBtn = e.target.closest('.js-ingredient-card-close');

            if (card.classList.contains('is-expanded')) {
              collapseExpandedCardAnimated(page);
              return;
            }

            if (closeBtn) {
              collapseExpandedCardAnimated(page);
              return;
            }

            expandCard(card, page);
          });
        });
      });

      if (tribexIngredientsDocCollapseBound) return;
      tribexIngredientsDocCollapseBound = true;

      document.addEventListener('click', function (e) {
        if (e.target.closest('.js-ingredient-card')) return;
        if (e.target.closest('.js-ingredients-hint')) return;
        document.querySelectorAll('.ingredients-benefits-list__page').forEach(function (page) {
          collapseExpandedCardAnimated(page);
        });
      });
    }

    function expandFirstIngredientCardOnLoad(section) {
      if (!section || section.getAttribute('data-auto-expand-first') === 'false') return;
      var page = section.querySelector('.ingredients-benefits-list__page');
      if (!page) return;
      var card = page.querySelector('.js-ingredient-card');
      if (!card) return;

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          expandCard(card, page);
          var tid = window.setTimeout(function () {
            section.removeAttribute('data-ib-auto-collapse-timer');
            if (!card.classList.contains('is-expanded')) return;
            collapseExpandedCardAnimated(page);
          }, 2000);
          section.setAttribute('data-ib-auto-collapse-timer', String(tid));
        });
      });
    }

    function bindUsageHint(section) {
      var hint = section.querySelector('.js-ingredients-hint');
      if (!hint || hint.getAttribute('data-hint-bound') === 'true') return;

      var storageKey = hint.getAttribute('data-hint-storage-key') || 'tribex_ingredients_benefits_hint';
      var panel = hint.querySelector('.ingredients-benefits-list__hint-panel');

      if (window.sessionStorage) {
        try {
          if (sessionStorage.getItem(storageKey) === '1') {
            hint.setAttribute('aria-hidden', 'true');
            hint.setAttribute('data-hint-bound', 'true');
            return;
          }
        } catch (err) {}
      }

      var onKeydown = function (e) {
        if (e.key === 'Escape') dismissHint();
      };

      function dismissHint() {
        if (!hint.classList.contains('is-visible')) return;
        hint.classList.remove('is-visible');
        hint.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('ingredients-benefits-hint-open');
        document.removeEventListener('keydown', onKeydown);
        if (window.sessionStorage) {
          try {
            sessionStorage.setItem(storageKey, '1');
          } catch (e2) {}
        }
      }

      function showHint() {
        hint.classList.add('is-visible');
        hint.setAttribute('aria-hidden', 'false');
        document.body.classList.add('ingredients-benefits-hint-open');
        document.addEventListener('keydown', onKeydown);
        var cta = hint.querySelector('.ingredients-benefits-list__hint-cta');
        if (cta && typeof cta.focus === 'function') {
          window.setTimeout(function () {
            cta.focus();
          }, 80);
        }
      }

      hint.querySelectorAll('.js-ingredients-hint-dismiss').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          dismissHint();
        });
      });

      if (panel) {
        panel.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      }

      hint.setAttribute('data-hint-bound', 'true');

      if (window.requestAnimationFrame) {
        requestAnimationFrame(function () {
          window.setTimeout(showHint, 160);
        });
      } else {
        window.setTimeout(showHint, 200);
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.ingredients-benefits-list').forEach(function (section) {
        bindIngredientsSlider(section);
        bindCardExpansion(section);
        expandFirstIngredientCardOnLoad(section);
        bindUsageHint(section);
      });
    });

    document.addEventListener('shopify:section:load', function (event) {
      var target = event.target;
      if (!target || !target.querySelector) return;
      var inner = target.querySelector('.ingredients-benefits-list');
      if (inner) {
        inner.removeAttribute('data-ingredients-slider-bound');
        inner.removeAttribute('data-card-expansion-bound');
        var hint = inner.querySelector('.js-ingredients-hint');
        if (hint) hint.removeAttribute('data-hint-bound');
        bindIngredientsSlider(inner);
        bindCardExpansion(inner);
        expandFirstIngredientCardOnLoad(inner);
        bindUsageHint(inner);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-founders"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const DEMO_MS = 2600;
    const mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initFoundersFlipDemo(root) {
      if (!mqHover.matches || mqReduce.matches) return;

      const target = root.querySelector('[data-osf-flip-demo]');
      if (!target) return;

      let started = false;

      function startDemo() {
        if (started) return;
        started = true;
        observer.disconnect();
        target.classList.add('osf__flip--demo-flip');
        window.setTimeout(function () {
          target.classList.remove('osf__flip--demo-flip');
        }, DEMO_MS);
      }

      const observer = new IntersectionObserver(
        function (entries) {
          for (let i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              startDemo();
              return;
            }
          }
        },
        { threshold: 0.28, rootMargin: '0px 0px -6% 0px' }
      );

      observer.observe(root);
    }

    document.querySelectorAll('.osf').forEach(initFoundersFlipDemo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-benefits"] && !Shopify.designMode) return;
  try {
    

(() => {

  const SELECTOR =
    '[data-tribex-live]';


  function initializeSection(section) {

    if (
      !section ||
      section.dataset.tribexLiveReady === 'true'
    ) {
      return;
    }


    section.dataset.tribexLiveReady =
      'true';


    const videos =
      Array.from(
        section.querySelectorAll(
          '[data-tribex-video]'
        )
      );



    /* ======================================
       PAUSE ALL OTHER VIDEOS
    ====================================== */

    function pauseOtherVideos(
      currentVideo
    ) {

      videos.forEach((video) => {

        if (
          video === currentVideo
        ) {
          return;
        }


        if (!video.paused) {
          video.pause();
        }


        const card =
          video.closest(
            '[data-video-card]'
          );


        if (
          card &&
          video.currentTime > 0
        ) {

          card.classList.remove(
            'is-playing'
          );

          card.classList.add(
            'is-paused'
          );

        }

      });

    }



    /* ======================================
       SETUP EACH VIDEO
    ====================================== */

    videos.forEach((video) => {

      video.autoplay = false;

      video.loop = false;

      video.controls = false;

      video.playsInline = true;


      video.removeAttribute(
        'autoplay'
      );


      video.removeAttribute(
        'loop'
      );


      video.removeAttribute(
        'controls'
      );


      video.setAttribute(
        'playsinline',
        ''
      );


      video.setAttribute(
        'webkit-playsinline',
        ''
      );



      /* PLAY EVENT */

      video.addEventListener(
        'play',
        () => {

          pauseOtherVideos(video);


          const card =
            video.closest(
              '[data-video-card]'
            );


          if (!card) {
            return;
          }


          card.classList.add(
            'has-started'
          );


          card.classList.add(
            'is-playing'
          );


          card.classList.remove(
            'is-paused'
          );

        }
      );



      /* PAUSE EVENT */

      video.addEventListener(
        'pause',
        () => {

          const card =
            video.closest(
              '[data-video-card]'
            );


          if (!card) {
            return;
          }


          card.classList.remove(
            'is-playing'
          );


          if (!video.ended) {

            card.classList.add(
              'is-paused'
            );

          }

        }
      );



      /* VIDEO FINISHED */

      video.addEventListener(
        'ended',
        () => {

          const card =
            video.closest(
              '[data-video-card]'
            );


          if (!card) {
            return;
          }


          card.classList.remove(
            'is-playing'
          );


          card.classList.add(
            'is-paused'
          );


          video.currentTime = 0;

        }
      );

    });



    /* ======================================
       BIG INITIAL PLAY BUTTON
    ====================================== */

    section
      .querySelectorAll(
        '[data-tribex-start]'
      )
      .forEach((button) => {

        button.addEventListener(
          'click',
          (event) => {

            event.preventDefault();

            event.stopPropagation();


            const card =
              button.closest(
                '[data-video-card]'
              );


            const video =
              card &&
              card.querySelector(
                '[data-tribex-video]'
              );


            if (!video) {
              return;
            }


            pauseOtherVideos(video);


            /*
              User tapped Play,
              so sound is allowed.
            */

            video.muted = false;

            video.volume = 1;


            card.classList.remove(
              'is-muted'
            );


            const playPromise =
              video.play();


            if (
              playPromise &&
              typeof playPromise.catch ===
              'function'
            ) {

              playPromise.catch(
                () => {}
              );

            }

          }
        );

      });



    /* ======================================
       CUSTOM PLAY / PAUSE
    ====================================== */

    section
      .querySelectorAll(
        '[data-tribex-toggle-play]'
      )
      .forEach((button) => {

        button.addEventListener(
          'click',
          (event) => {

            event.preventDefault();

            event.stopPropagation();


            const card =
              button.closest(
                '[data-video-card]'
              );


            const video =
              card &&
              card.querySelector(
                '[data-tribex-video]'
              );


            if (!video) {
              return;
            }


            if (video.paused) {

              pauseOtherVideos(
                video
              );


              const playPromise =
                video.play();


              if (
                playPromise &&
                typeof playPromise.catch ===
                'function'
              ) {

                playPromise.catch(
                  () => {}
                );

              }


            } else {

              video.pause();

            }

          }
        );

      });



    /* ======================================
       CUSTOM MUTE / UNMUTE
    ====================================== */

    section
      .querySelectorAll(
        '[data-tribex-mute]'
      )
      .forEach((button) => {

        button.addEventListener(
          'click',
          (event) => {

            event.preventDefault();

            event.stopPropagation();


            const card =
              button.closest(
                '[data-video-card]'
              );


            const video =
              card &&
              card.querySelector(
                '[data-tribex-video]'
              );


            if (!video) {
              return;
            }


            video.muted =
              !video.muted;


            card.classList.toggle(
              'is-muted',
              video.muted
            );


            button.setAttribute(
              'aria-label',
              video.muted
                ? 'Unmute video'
                : 'Mute video'
            );

          }
        );

      });



    /* ======================================
       PAUSE WHEN LEAVING PAGE
    ====================================== */

    document.addEventListener(
      'visibilitychange',
      () => {

        if (!document.hidden) {
          return;
        }


        videos.forEach(
          (video) => {

            if (!video.paused) {

              video.pause();

            }

          }
        );

      }
    );

  }



  /* ========================================
     INITIALIZE ALL SECTIONS
  ======================================== */

  function initializeAll(
    root = document
  ) {

    root
      .querySelectorAll(
        SELECTOR
      )
      .forEach(
        initializeSection
      );

  }



  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll()
    );


  } else {

    initializeAll();

  }



  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initializeAll(
        event.target
      );

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tribex-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPtribexFaq(section) {
      section.querySelectorAll('.js-ptribex-faq-item').forEach(function (item) {
        var btn = item.querySelector('.js-ptribex-faq-btn');
        var answer = item.querySelector('.ptribex-faq__answer');
        if (!btn || !answer) return;

        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');

          section.querySelectorAll('.js-ptribex-faq-item').forEach(function (other) {
            other.classList.remove('is-open');
            var otherBtn = other.querySelector('.js-ptribex-faq-btn');
            var otherAnswer = other.querySelector('.ptribex-faq__answer');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
            if (otherAnswer) otherAnswer.setAttribute('hidden', '');
          });

          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            answer.removeAttribute('hidden');
          }
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.ptribex-faq').forEach(initPtribexFaq);
    });

    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target && e.target.querySelector('.ptribex-faq');
      if (s) initPtribexFaq(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tribex-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPtribexMain(section) {
      var slides = section.querySelectorAll('.js-ptribex-slide');
      var mediaViewer = section.querySelector('.js-ptribex-media-viewer');
      var mobileGalleryQuery = window.matchMedia('(max-width: 900px)');
      var lastGallerySwipeAt = 0;
      var paymentWrap = section.querySelector('.js-ptribex-payment-wrap');

      /* Force the updated shipping message even when Shopify has older saved
         block settings in the Theme Editor. Schema defaults alone do not
         overwrite values that were already saved. */
      function enforceShippingTodayCopy() {
        section.querySelectorAll('.ptribex-main__sub-perks li').forEach(function (item) {
          if (/shipping/i.test(item.textContent || '')) {
            var desiredPerkText = '✓ Free shipping today!';
            if (item.textContent.trim() !== desiredPerkText) {
              item.textContent = desiredPerkText;
            }
          }
        });

        section.querySelectorAll('.ptribex-main__shipping-note').forEach(function (note) {
          var desiredNoteText = 'Free shipping today!';
          if (note.textContent.trim() !== desiredNoteText) {
            note.textContent = desiredNoteText;
          }
        });
      }

      enforceShippingTodayCopy();

      function updateCheckoutPaymentOrder() {
        var actions = section.querySelector('.js-ptribex-checkout-actions');
        var checkoutBtn = section.querySelector('.js-ptribex-checkout-btn');
        var addBtn = section.querySelector('.js-ptribex-add-btn');
        var termsWrap = section.querySelector('.js-ptribex-terms-wrap');

        if (!actions || !paymentWrap || !checkoutBtn || !addBtn) return;

        /* Keep the visible order stable:
           1) custom Checkout button
           2) Shopify dynamic button, usually Buy with Shop
           3) Add to cart
           4) subscription/payment words */
        if (checkoutBtn.parentNode === actions) {
          actions.insertBefore(checkoutBtn, actions.firstChild);
        }

        if (paymentWrap.parentNode === actions) {
          actions.insertBefore(paymentWrap, checkoutBtn.nextSibling);
        }

        var shopifyButton = paymentWrap.querySelector('.shopify-payment-button');
        if (shopifyButton) {
          shopifyButton.querySelectorAll('.shopify-payment-button__more-options').forEach(function (button) {
            button.style.display = 'none';
            button.setAttribute('aria-hidden', 'true');
            button.setAttribute('tabindex', '-1');
          });
        }

        if (addBtn.parentNode === actions) {
          actions.insertBefore(addBtn, paymentWrap.nextSibling);
        }

        if (termsWrap && termsWrap.parentNode === actions) {
          actions.appendChild(termsWrap);
        }

        var termSelectors = [
          '.shopify-payment-terms',
          '[data-shopify="payment-terms"]',
          '.shopify_subscriptions_app_policy',
          '.shopify_subscriptions_app_block',
          '[class*="subscription"][class*="policy"]',
          '[class*="subscription"][class*="terms"]',
          '[class*="selling-plan"][class*="policy"]'
        ];

        var moved = [];
        termSelectors.forEach(function (selector) {
          section.querySelectorAll(selector).forEach(function (el) {
            if (!termsWrap) return;
            if (el === termsWrap || termsWrap.contains(el)) return;
            if (el.closest('.js-ptribex-plan-section')) return;
            if (el.closest('.js-ptribex-sub-wrapper')) return;
            if (el.closest('.js-ptribex-terms-wrap')) return;
            moved.push(el);
          });
        });

        moved.forEach(function (el) {
          el.classList.add('ptribex-main__checkout-terms');
          termsWrap.appendChild(el);
        });
      }

      function goDirectlyToCheckout() {
        var checkoutBtn = section.querySelector('.js-ptribex-checkout-btn');
        var form = section.querySelector('#ptribex-form');
        if (!checkoutBtn || !form || checkoutBtn.disabled) return;

        var planRadio = section.querySelector('.js-ptribex-plan-radio:checked');
        var isSub = planRadio && planRadio.value === 'sub';

        if (isSub && hasSellingPlans) {
          var freq = getCheckedFreqRadio();
          var planId = freq ? freq.getAttribute('data-selling-plan-id') : '';

          if (!planId) {
            return;
          }

          syncSellingPlanInput();
        }

        syncSubscriptionDiscountProperty();

        checkoutBtn.disabled = true;
        checkoutBtn.textContent = 'Loading...';

        var formData = new FormData(form);
        formData.set('quantity', '1');

        /* Start a fresh checkout every time: clear the old cart, then add one item. */
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          }
        })
          .then(function (clearResponse) {
            if (!clearResponse.ok) {
              throw new Error('Unable to clear cart');
            }

            return fetch('/cart/add.js', {
              method: 'POST',
              body: formData,
              headers: {
                Accept: 'application/json'
              }
            });
          })
          .then(function (addResponse) {
            if (!addResponse.ok) {
              throw new Error('Unable to add item to cart');
            }

            window.location.href = '/checkout';
          })
          .catch(function (error) {
            console.error('Direct checkout failed:', error);
            checkoutBtn.disabled = false;
            checkoutBtn.textContent = 'Checkout';
            window.alert('We could not start checkout. Please try again.');
          });
      }

      function scheduleCheckoutPaymentOrder() {
        updateCheckoutPaymentOrder();
        window.setTimeout(updateCheckoutPaymentOrder, 200);
        window.setTimeout(updateCheckoutPaymentOrder, 800);
        window.setTimeout(updateCheckoutPaymentOrder, 1600);
      }

      scheduleCheckoutPaymentOrder();
      enforceShippingTodayCopy();

      if (window.MutationObserver) {
        var shippingCopyObserver = new MutationObserver(function () {
          window.requestAnimationFrame(enforceShippingTodayCopy);
        });
        shippingCopyObserver.observe(section, {
          childList: true,
          subtree: true
        });
      }

      if (paymentWrap && window.MutationObserver) {
        var paymentObserver = new MutationObserver(function () {
          window.requestAnimationFrame(updateCheckoutPaymentOrder);
        });
        paymentObserver.observe(paymentWrap, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      var directCheckoutButton = section.querySelector('.js-ptribex-checkout-btn');
      if (directCheckoutButton) {
        directCheckoutButton.addEventListener('click', goDirectlyToCheckout);
      }


      function getActiveSlideIndex() {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains('is-active')) return i;
        }
        return 0;
      }

      function activateSlideByIndex(index) {
        if (!slides.length) return;
        var nextIndex = Math.max(0, Math.min(slides.length - 1, index));
        var target = slides[nextIndex];
        if (!target) return;

        var targetId = target.id;

        section.querySelectorAll('.js-ptribex-thumb').forEach(function (thumb) {
          var match = thumb.getAttribute('data-target') === targetId;
          thumb.classList.toggle('is-active', match);
          thumb.setAttribute('aria-current', match ? 'true' : 'false');
        });

        slides.forEach(function (slide) {
          var active = slide.id === targetId;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        if (mobileGalleryQuery.matches) {
          var activeThumb = section.querySelector('.js-ptribex-thumb.is-active');
          if (activeThumb) {
            activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
          }
        }
      }

      section.querySelectorAll('.js-ptribex-thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var targetId = thumb.getAttribute('data-target');
          var target = targetId ? section.querySelector('#' + targetId) : null;
          if (!target) return;
          activateSlideByIndex(Array.prototype.indexOf.call(slides, target));
        });
      });

      if (mediaViewer && slides.length > 1) {
        var touchStartX = 0;
        var touchStartY = 0;
        var touchActive = false;
        var swipeThreshold = 48;

        mediaViewer.addEventListener(
          'touchstart',
          function (e) {
            if (!mobileGalleryQuery.matches || e.touches.length !== 1) return;
            touchActive = true;
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            mediaViewer.classList.remove('is-swiping');
          },
          { passive: true }
        );

        mediaViewer.addEventListener(
          'touchmove',
          function (e) {
            if (!touchActive || !mobileGalleryQuery.matches || e.touches.length !== 1) return;
            var dx = e.touches[0].clientX - touchStartX;
            var dy = e.touches[0].clientY - touchStartY;
            if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) {
              mediaViewer.classList.add('is-swiping');
            }
          },
          { passive: true }
        );

        mediaViewer.addEventListener(
          'touchend',
          function (e) {
            if (!touchActive || !mobileGalleryQuery.matches) return;
            touchActive = false;

            var touch = e.changedTouches[0];
            if (!touch) return;

            var dx = touch.clientX - touchStartX;
            var dy = touch.clientY - touchStartY;

            mediaViewer.classList.remove('is-swiping');

            if (Math.abs(dx) < swipeThreshold || Math.abs(dx) <= Math.abs(dy)) return;

            var currentIndex = getActiveSlideIndex();
            if (dx < 0) {
              activateSlideByIndex(currentIndex + 1);
            } else {
              activateSlideByIndex(currentIndex - 1);
            }

            lastGallerySwipeAt = Date.now();
          },
          { passive: true }
        );

        mediaViewer.addEventListener(
          'touchcancel',
          function () {
            touchActive = false;
            mediaViewer.classList.remove('is-swiping');
          },
          { passive: true }
        );
      }

      var dialog = section.querySelector('.js-ptribex-facts-dialog');
      var factsBtn = section.querySelector('.js-ptribex-facts-open');

      if (dialog && factsBtn && typeof dialog.showModal === 'function') {
        factsBtn.addEventListener('click', function () {
          dialog.showModal();
        });
        section.querySelectorAll('.js-ptribex-facts-close').forEach(function (btn) {
          btn.addEventListener('click', function () {
            dialog.close();
          });
        });
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) dialog.close();
        });
      }

      var mediaLightbox = section.querySelector('.js-ptribex-media-lightbox');
      var mediaLightboxImg = section.querySelector('.js-ptribex-media-lightbox-img');

      if (mediaLightbox && mediaLightboxImg && typeof mediaLightbox.showModal === 'function') {
        section.querySelectorAll('.js-ptribex-zoom-open').forEach(function (zoomBtn) {
          zoomBtn.addEventListener('click', function () {
            if (Date.now() - lastGallerySwipeAt < 350) return;
            var zoomSrc = zoomBtn.getAttribute('data-zoom-src');
            var zoomAlt = zoomBtn.getAttribute('data-zoom-alt') || '';
            if (!zoomSrc) return;
            mediaLightboxImg.src = zoomSrc;
            mediaLightboxImg.alt = zoomAlt;
            mediaLightbox.showModal();
          });
        });

        section.querySelectorAll('.js-ptribex-media-close').forEach(function (btn) {
          btn.addEventListener('click', function () {
            mediaLightbox.close();
          });
        });

        mediaLightbox.addEventListener('click', function (e) {
          if (e.target === mediaLightbox) mediaLightbox.close();
        });

        mediaLightbox.addEventListener('close', function () {
          mediaLightboxImg.removeAttribute('src');
        });
      }

      var form = section.querySelector('#ptribex-form');
      var variantInput = section.querySelector('.js-ptribex-variant-id');
      var sellingPlanInput = section.querySelector('.js-ptribex-selling-plan-input');
      var subscriptionDiscountProperty = section.querySelector('.js-ptribex-sub-discount-property');
      var planSection = section.querySelector('.js-ptribex-plan-section');
      var requiresSellingPlan = planSection && planSection.getAttribute('data-requires-selling-plan') === 'true';
      var hasSellingPlans = planSection && planSection.getAttribute('data-has-selling-plans') === 'true';

      function getActiveFreqPanel() {
        if (!variantInput) return null;
        return section.querySelector('.js-ptribex-variant-freqs[data-variant-id="' + variantInput.value + '"]');
      }

      function getCheckedFreqRadio() {
        var panel = getActiveFreqPanel();
        if (!panel) return null;
        return panel.querySelector('.js-ptribex-freq:checked');
      }

      function formatMoneyFromCents(cents) {
        if (cents && window.Shopify && typeof Shopify.formatMoney === 'function') {
          return Shopify.formatMoney(Number(cents));
        }
        return '$' + (Number(cents) / 100).toFixed(2);
      }

      function updateSaveBadgeFromSelection() {
        var badge = section.querySelector('.js-ptribex-save-badge');
        var planRadio = section.querySelector('.js-ptribex-plan-radio:checked');
        var isSub = planRadio && planRadio.value === 'sub';
        var freq = getCheckedFreqRadio();
        if (!badge) return;

        badge.textContent = '24% off';
        badge.hidden = !isSub || !freq;
      }

      function updateSubPriceDisplay() {
        var freq = getCheckedFreqRadio();
        var priceEl = section.querySelector('.js-ptribex-sub-price');
        if (!freq || !priceEl) return;
        var monthlyCents = freq.getAttribute('data-monthly-cents');
        if (monthlyCents) {
          priceEl.textContent = formatMoneyFromCents(monthlyCents);
        }
      }

      /* Keep every lower subscription-card badge consistent. */
      function updateFrequencyOptionSavings() {
        section.querySelectorAll('.js-ptribex-variant-freqs').forEach(function (panel) {
          panel.querySelectorAll('.ptribex-main__sub-option').forEach(function (option) {
            var badge = option.querySelector('.ptribex-main__sub-option-discount');

            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'ptribex-main__sub-option-discount';

              var meta = option.querySelector('.ptribex-main__sub-option-meta');
              var right = option.querySelector('.ptribex-main__sub-option-right');
              (meta || right || option).appendChild(badge);
            }

            badge.textContent = '24% off';
            badge.hidden = false;
          });
        });
      }

      function syncSubscriptionDiscountProperty() {
        if (!subscriptionDiscountProperty) return;

        var planRadio = section.querySelector('.js-ptribex-plan-radio:checked');
        var isSub = planRadio && planRadio.value === 'sub';

        subscriptionDiscountProperty.disabled = !isSub;
      }

      function syncSellingPlanInput() {
        if (!sellingPlanInput) return;
        var planRadio = section.querySelector('.js-ptribex-plan-radio:checked');
        var isSub = planRadio && planRadio.value === 'sub';

        if (!hasSellingPlans || !isSub) {
          sellingPlanInput.value = '';
          sellingPlanInput.setAttribute('disabled', 'disabled');
          sellingPlanInput.removeAttribute('name');
          return;
        }

        var freq = getCheckedFreqRadio();
        var planId = freq ? freq.getAttribute('data-selling-plan-id') : '';

        sellingPlanInput.setAttribute('name', 'selling_plan');
        sellingPlanInput.removeAttribute('disabled');

        if (planId) {
          sellingPlanInput.value = planId;
        } else {
          sellingPlanInput.value = '';
        }

        if (form) {
          form.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      function updatePlanSelectionUI() {
        var planRadio = section.querySelector('.js-ptribex-plan-radio:checked');
        section.querySelectorAll('.js-ptribex-plan').forEach(function (row) {
          var active = row.getAttribute('data-plan') === (planRadio ? planRadio.value : '');
          row.classList.toggle('ptribex-main__plan-row--selected', active);

          var planLabel = row.querySelector('.ptribex-main__plan-row');
          if (planLabel) {
            planLabel.classList.toggle('ptribex-main__plan-row--selected', active);
          }

          var onetimeLabel = row.querySelector('.js-ptribex-onetime-row');
          if (onetimeLabel) {
            onetimeLabel.classList.toggle('ptribex-main__plan-row--muted', !active);
          }
        });

        var isSub = planRadio && planRadio.value === 'sub';
        var subWrapper = section.querySelector('.js-ptribex-sub-wrapper');
        var subOptions = section.querySelector('.js-ptribex-sub-options');

        if (subWrapper) {
          subWrapper.classList.toggle('is-disabled', !isSub);
        }

        if (subOptions) {
          subOptions.hidden = !isSub;
        }

        syncSellingPlanInput();
        syncSubscriptionDiscountProperty();
        updateSubPriceDisplay();
        updateSaveBadgeFromSelection();
      }

      function showVariantFrequencies(variantId) {
        section.querySelectorAll('.js-ptribex-variant-freqs').forEach(function (panel) {
          var match = panel.getAttribute('data-variant-id') === String(variantId);
          panel.classList.toggle('ptribex-main__variant-freqs--hidden', !match);
        });

        var panel = getActiveFreqPanel();
        if (!panel) return;

        var checked = panel.querySelector('.js-ptribex-freq:checked');
        if (!checked) {
          var fallback = panel.querySelector('.js-ptribex-freq:not([disabled])');
          if (fallback) fallback.checked = true;
        }

        panel.querySelectorAll('.ptribex-main__sub-option').forEach(function (opt) {
          var radio = opt.querySelector('.js-ptribex-freq');
          opt.classList.toggle('is-selected', radio && radio.checked);
        });

        updateFrequencyOptionSavings();
        updatePlanSelectionUI();
      }

      function setVariant(variantId, price, priceFormatted, compareAtPrice, compareAtPriceFormatted) {
        if (!variantInput || !variantId) return;
        variantInput.value = variantId;

        var onetimePrice = section.querySelector('.js-ptribex-onetime-price');
        if (onetimePrice && priceFormatted) onetimePrice.textContent = priceFormatted;

        var numericPrice = Number(price) || 0;
        var numericCompareAt = Number(compareAtPrice) || 0;

        /* Use Shopify's compare-at price as the subscription reference price. */
        var comparePrice = section.querySelector('.js-ptribex-onetime-compare');
        var subscriptionCompareCents = numericCompareAt > numericPrice
          ? numericCompareAt
          : numericPrice;
        var subscriptionCompareFormatted = numericCompareAt > numericPrice && compareAtPriceFormatted
          ? compareAtPriceFormatted
          : priceFormatted;

        if (comparePrice) {
          comparePrice.textContent = subscriptionCompareFormatted || formatMoneyFromCents(subscriptionCompareCents);
          comparePrice.setAttribute('data-compare-cents', String(subscriptionCompareCents));
        }

        /* One-time sale display uses Shopify's compare-at price. */
        var saleCompare = section.querySelector('.js-ptribex-onetime-sale-compare');
        var saleBadge = section.querySelector('.js-ptribex-onetime-save');
        var saleValue = section.querySelector('.js-ptribex-onetime-save-value');
        var hasOneTimeSale = numericCompareAt > numericPrice && numericPrice > 0;

        if (saleCompare) {
          saleCompare.hidden = !hasOneTimeSale;
          saleCompare.textContent = hasOneTimeSale && compareAtPriceFormatted
            ? compareAtPriceFormatted
            : '';
        }

        if (saleBadge) saleBadge.hidden = !hasOneTimeSale;

        if (saleValue && hasOneTimeSale) {
          var salePercent = Math.round(
            ((numericCompareAt - numericPrice) / numericCompareAt) * 1000
          ) / 10;

          saleValue.textContent = Number.isInteger(salePercent)
            ? salePercent.toFixed(0)
            : salePercent.toFixed(1);
        }

        showVariantFrequencies(variantId);

        if (form) {
          form.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      section.querySelectorAll('.js-ptribex-plan-radio').forEach(function (radio) {
        radio.addEventListener('change', updatePlanSelectionUI);
      });

      section.querySelectorAll('.js-ptribex-freq').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var panel = radio.closest('.js-ptribex-variant-freqs');
          if (!panel) return;

          panel.querySelectorAll('.ptribex-main__sub-option').forEach(function (opt) {
            var optRadio = opt.querySelector('.js-ptribex-freq');
            opt.classList.toggle('is-selected', optRadio && optRadio.checked);
          });

          updatePlanSelectionUI();
        });
      });

      section.querySelectorAll('.js-ptribex-flavor').forEach(function (btn) {
        btn.addEventListener('click', function () {
          section.querySelectorAll('.js-ptribex-flavor').forEach(function (b) {
            b.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');

          var variantId = btn.getAttribute('data-variant-id');
          if (!variantId) return;

          var dataEl = section.querySelector('.js-ptribex-product-data');
          var price = 0;
          var priceFormatted = null;
          var compareAtPrice = 0;
          var compareAtPriceFormatted = null;

          if (dataEl) {
            try {
              var data = JSON.parse(dataEl.textContent);
              var match = (data.variants || []).find(function (v) {
                return String(v.id) === String(variantId);
              });

              if (match) {
                price = match.price;
                priceFormatted = match.priceFormatted;
                compareAtPrice = match.compareAtPrice;
                compareAtPriceFormatted = match.compareAtPriceFormatted;
              }
            } catch (e) {
              /* ignore parse errors */
            }
          }

          setVariant(
            variantId,
            price,
            priceFormatted,
            compareAtPrice,
            compareAtPriceFormatted
          );
        });
      });

      if (form) {
        form.addEventListener('submit', function (e) {
          var planRadio = section.querySelector('.js-ptribex-plan-radio:checked');
          var isSub = planRadio && planRadio.value === 'sub';

          if (isSub && hasSellingPlans) {
            var freq = getCheckedFreqRadio();
            var planId = freq ? freq.getAttribute('data-selling-plan-id') : '';

            if (!planId) {
              e.preventDefault();
              return;
            }

            syncSellingPlanInput();
          }
        });
      }

      updateFrequencyOptionSavings();
      updatePlanSelectionUI();
      if (requiresSellingPlan) {
        var subPlan = section.querySelector('.js-ptribex-plan-radio[value="sub"]');
        if (subPlan) {
          subPlan.checked = true;
          updatePlanSelectionUI();
        }
      }

      section.querySelectorAll('.js-ptribex-main-faq-item').forEach(function (item) {
        var faqBtn = item.querySelector('.js-ptribex-main-faq-btn');
        var faqAnswer = item.querySelector('.ptribex-main__faq-answer');
        if (!faqBtn || !faqAnswer) return;

        faqBtn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');

          section.querySelectorAll('.js-ptribex-main-faq-item').forEach(function (other) {
            other.classList.remove('is-open');
            var ob = other.querySelector('.js-ptribex-main-faq-btn');
            var oa = other.querySelector('.ptribex-main__faq-answer');
            if (ob) ob.setAttribute('aria-expanded', 'false');
            if (oa) oa.setAttribute('hidden', '');
          });

          if (!isOpen) {
            item.classList.add('is-open');
            faqBtn.setAttribute('aria-expanded', 'true');
            faqAnswer.removeAttribute('hidden');
          }
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.ptribex-main').forEach(initPtribexMain);
    });

    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target && e.target.querySelector('.ptribex-main');
      if (s) initPtribexMain(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tribex-trust"] && !Shopify.designMode) return;
  try {
    
 (() => {
   const SELECTOR = '.ptribex-trust[data-section-id]';
   const VERIFIED_SELECTOR = [
     '.jdgm-rev__buyer-badge',
     '.jdgm-rev__buyer-badge-wrapper',
     '.jdgm-verified-badge',
     '.jdgm-verified-buyer',
     '.jdgm-rev__verified-buyer',
     '[class*="verified-buyer"]',
     '[class*="verified_buyer"]'
   ].join(',');


   const SCROLL_BODY_SELECTOR = '.ptribex-trust__card-body, .jdgm-rev__body';
   const SCROLL_CARD_SELECTOR = '.ptribex-trust__card, .jdgm-rev';


   function destroyEqualScrollbars(root) {
     if (!root) return;

     root.querySelectorAll(SCROLL_BODY_SELECTOR).forEach((body) => {
       body._tbxEqualScrollbarCleanup?.();
       delete body._tbxEqualScrollbarCleanup;
     });

     root.querySelectorAll('.ptribex-trust__equal-scrollbar').forEach((bar) => bar.remove());
   }


   function initEqualScrollbars(root) {
     if (!root) return;

     root.querySelectorAll(SCROLL_CARD_SELECTOR).forEach((card) => {
       const body = card.querySelector(SCROLL_BODY_SELECTOR);
       if (!body || body._tbxEqualScrollbarCleanup) return;

       const bar = document.createElement('span');
       bar.className = 'ptribex-trust__equal-scrollbar';
       bar.setAttribute('aria-hidden', 'true');
       card.appendChild(bar);

       let activePointerId = null;
       let pointerStartY = 0;
       let scrollStartTop = 0;
       let resizeFrame = null;

       const update = () => {
         resizeFrame = null;

         const maxScroll = Math.max(0, body.scrollHeight - body.clientHeight);
         const cardRect = card.getBoundingClientRect();
         const bodyRect = body.getBoundingClientRect();
         const thumbHeight = bar.offsetHeight || 1;
         const travel = Math.max(0, bodyRect.height - thumbHeight);
         const progress = maxScroll > 0 ? body.scrollTop / maxScroll : 0;
         const top = (bodyRect.top - cardRect.top) + (travel * progress);
         const right = Math.max(5, cardRect.right - bodyRect.right + 1);

         bar.style.top = `${top}px`;
         bar.style.right = `${right}px`;
         bar.classList.toggle('is-visible', maxScroll > 1);
       };

       const scheduleUpdate = () => {
         if (resizeFrame !== null) return;
         resizeFrame = window.requestAnimationFrame(update);
       };

       const finishBarDrag = (event) => {
         if (activePointerId === null) return;
         if (event?.pointerId !== undefined && event.pointerId !== activePointerId) return;

         if (bar.hasPointerCapture?.(activePointerId)) {
           bar.releasePointerCapture(activePointerId);
         }

         activePointerId = null;
         bar.classList.remove('is-dragging');
       };

       const handleBarDown = (event) => {
         if (!bar.classList.contains('is-visible')) return;

         event.preventDefault();
         event.stopPropagation();

         activePointerId = event.pointerId;
         pointerStartY = event.clientY;
         scrollStartTop = body.scrollTop;
         bar.classList.add('is-dragging');
         bar.setPointerCapture?.(activePointerId);
       };

       const handleBarMove = (event) => {
         if (event.pointerId !== activePointerId) return;

         event.preventDefault();
         event.stopPropagation();

         const maxScroll = Math.max(0, body.scrollHeight - body.clientHeight);
         const travel = Math.max(1, body.clientHeight - bar.offsetHeight);
         const deltaY = event.clientY - pointerStartY;

         body.scrollTop = scrollStartTop + ((deltaY / travel) * maxScroll);
       };

       body.addEventListener('scroll', scheduleUpdate, { passive: true });
       bar.addEventListener('pointerdown', handleBarDown);
       bar.addEventListener('pointermove', handleBarMove);
       bar.addEventListener('pointerup', finishBarDrag);
       bar.addEventListener('pointercancel', finishBarDrag);
       bar.addEventListener('lostpointercapture', finishBarDrag);

       const resizeObserver = new ResizeObserver(scheduleUpdate);
       resizeObserver.observe(body);
       resizeObserver.observe(card);

       body._tbxEqualScrollbarCleanup = () => {
         body.removeEventListener('scroll', scheduleUpdate);
         bar.removeEventListener('pointerdown', handleBarDown);
         bar.removeEventListener('pointermove', handleBarMove);
         bar.removeEventListener('pointerup', finishBarDrag);
         bar.removeEventListener('pointercancel', finishBarDrag);
         bar.removeEventListener('lostpointercapture', finishBarDrag);
         resizeObserver.disconnect();

         if (resizeFrame !== null) {
           window.cancelAnimationFrame(resizeFrame);
         }

         bar.remove();
       };

       scheduleUpdate();
     });
   }


   function removeVerifiedBuyer(root) {
     if (!root) return;


     root.querySelectorAll(VERIFIED_SELECTOR).forEach((element) => element.remove());


     root.querySelectorAll('span, div, p, small').forEach((element) => {
       if (element.children.length > 0) return;


       const value = element.textContent.replace(/\s+/g, ' ').trim();
       if (/^verified\s+(buyer|purchase|customer)$/i.test(value)) {
         element.remove();
       }
     });
   }


   function removeDuplicateIds(root) {
     if (!(root instanceof Element)) return;


     root.removeAttribute('id');
     root.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
   }


   function makeGeneratedClone(source) {
     const clone = source.cloneNode(true);


     clone.dataset.tbxGeneratedClone = 'true';
     clone.setAttribute('aria-hidden', 'true');
     removeDuplicateIds(clone);
     removeVerifiedBuyer(clone);


     clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
       element.setAttribute('tabindex', '-1');
     });


     return clone;
   }


   function getGap(track) {
     const styles = getComputedStyle(track);
     return Number.parseFloat(styles.columnGap || styles.gap) || 0;
   }


   function getStep(track, slide) {
     return slide ? slide.getBoundingClientRect().width + getGap(track) : 0;
   }


   function createDots(container, count, onSelect) {
     if (!container) return [];


     container.innerHTML = '';


     return Array.from({ length: count }, (_, index) => {
       const dot = document.createElement('button');
       dot.type = 'button';
       dot.className = `ptribex-trust__dot${index === 0 ? ' is-active' : ''}`;
       dot.setAttribute('aria-label', `Go to review ${index + 1}`);
       dot.addEventListener('click', () => onSelect(index));
       container.appendChild(dot);
       return dot;
     });
   }


   function initContinuousCarousel(section, root, track, sourceSlides, dotsContainer) {
     if (!root || !track || !sourceSlides.length || root.dataset.carouselReady === 'true') return;


     root.dataset.carouselReady = 'true';
     track.setAttribute('aria-live', 'off');


     const viewport = root.querySelector('.ptribex-trust__viewport');
     const previousButton = root.querySelector('.ptribex-trust__arrow--previous');
     const nextButton = root.querySelector('.ptribex-trust__arrow--next');
     const autoplayEnabled = section.dataset.autoplay === 'true';
     const desktopSecondsPerCard = Math.max(
       3,
       (Number.parseInt(section.dataset.speed, 10) || 5000) / 1000
     );
     const mobileSecondsPerCard = Math.max(
       6,
       (Number.parseInt(section.dataset.mobileSpeed, 10) || 18000) / 1000
     );
     const mobileQuery = window.matchMedia('(max-width: 680px)');
     const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


     let originals = sourceSlides.filter((slide) => !slide.hasAttribute('data-tbx-generated-clone'));
     let loopWidth = 0;
     let step = 0;
     let offset = 0;
     let pixelsPerMillisecond = 0;
     let frameId = null;
     let transitionFrameId = null;
     let lastTimestamp = null;
     let dots = [];
     let currentDot = -1;
     let resizeTimer = null;
     let destroyed = false;
     let pointerStartX = 0;
     let pointerStartOffset = 0;
     let activePointerId = null;
     let isDragging = false;
     let interactionResumeTimer = null;
     const pauseReasons = new Set();


     function getSecondsPerCard() {
       return mobileQuery.matches ? mobileSecondsPerCard : desktopSecondsPerCard;
     }


     function normalizeOffset(value) {
       if (!loopWidth) return value;


       while (value >= 0) value -= loopWidth;
       while (value < -loopWidth) value += loopWidth;


       return value;
     }


     function getActiveIndex() {
       if (!originals.length || !loopWidth || !step) return 0;


       const distance = ((-offset % loopWidth) + loopWidth) % loopWidth;
       return Math.round(distance / step) % originals.length;
     }


     function updateDots() {
       if (!dots.length) return;


       const activeIndex = getActiveIndex();
       if (activeIndex === currentDot) return;


       currentDot = activeIndex;


       dots.forEach((dot, index) => {
         const isActive = index === activeIndex;
         dot.classList.toggle('is-active', isActive);
         dot.setAttribute('aria-current', isActive ? 'true' : 'false');
       });
     }


     function applyTransform() {
       track.style.transform = `translate3d(${offset}px, 0, 0)`;
       updateDots();
     }


     function stopDesktopFrame() {
       if (frameId !== null) {
         window.cancelAnimationFrame(frameId);
         frameId = null;
       }


       lastTimestamp = null;
     }


     function stopTransition() {
       if (transitionFrameId !== null) {
         window.cancelAnimationFrame(transitionFrameId);
         transitionFrameId = null;
       }


       pauseReasons.delete('transition');
     }


     function stopAutoplayMotion() {
       stopDesktopFrame();
     }


     function shouldAutoplay() {
       return autoplayEnabled &&
         !reduceMotion &&
         !destroyed &&
         pauseReasons.size === 0 &&
         loopWidth > 0;
     }


     function tick(timestamp) {
       if (!shouldAutoplay()) {
         stopDesktopFrame();
         return;
       }


       if (lastTimestamp === null) lastTimestamp = timestamp;


       const elapsed = Math.min(48, timestamp - lastTimestamp);
       lastTimestamp = timestamp;


       offset = normalizeOffset(offset + (pixelsPerMillisecond * elapsed));
       applyTransform();


       frameId = window.requestAnimationFrame(tick);
     }


     function startDesktopFrame() {
       if (!shouldAutoplay() || frameId !== null) return;
       frameId = window.requestAnimationFrame(tick);
     }


     function animateBy(distance, duration = 620) {
       if (!step || !loopWidth || transitionFrameId !== null) return;


       stopAutoplayMotion();
       pauseReasons.add('transition');


       let startOffset = offset;
       let targetOffset = offset + distance;


       if (targetOffset >= 0) {
         startOffset -= loopWidth;
         targetOffset -= loopWidth;
       } else if (targetOffset < -loopWidth) {
         startOffset += loopWidth;
         targetOffset += loopWidth;
       }


       const startedAt = performance.now();


       function animate(timestamp) {
         const progress = Math.min(1, (timestamp - startedAt) / duration);
         const eased = 1 - Math.pow(1 - progress, 3);


         offset = startOffset + ((targetOffset - startOffset) * eased);
         applyTransform();


         if (progress < 1) {
           transitionFrameId = window.requestAnimationFrame(animate);
           return;
         }


         transitionFrameId = null;
         offset = normalizeOffset(targetOffset);
         applyTransform();
         pauseReasons.delete('transition');
         startAutoplay();
       }


       transitionFrameId = window.requestAnimationFrame(animate);
     }


     function startAutoplay() {
       if (!shouldAutoplay()) return;
       startDesktopFrame();
     }


     function pause(reason) {
       pauseReasons.add(reason);
       stopAutoplayMotion();
     }


     function resume(reason) {
       pauseReasons.delete(reason);
       startAutoplay();
     }


     function resumeAfterInteraction(reason, delay = 1100) {
       window.clearTimeout(interactionResumeTimer);
       interactionResumeTimer = window.setTimeout(() => {
         resume(reason);
       }, delay);
     }


     function clearGeneratedClones() {
       track.querySelectorAll('[data-tbx-generated-clone="true"]').forEach((clone) => clone.remove());
     }


     function prepareLoop() {
       stopAutoplayMotion();
       stopTransition();
       destroyEqualScrollbars(track);
       clearGeneratedClones();


       originals = Array.from(track.children);
       if (!originals.length || !viewport) return;


       originals.forEach((slide) => {
         slide.removeAttribute('aria-hidden');
         removeVerifiedBuyer(slide);
       });


       const minimumSequenceWidth = viewport.clientWidth + getStep(track, originals[0]);
       let baseSlides = [...originals];
       let safety = 0;


       const measureBaseWidth = () => {
         const first = baseSlides[0];
         const last = baseSlides[baseSlides.length - 1];


         if (!first || !last) return 0;


         return (last.offsetLeft + last.offsetWidth) - first.offsetLeft + getGap(track);
       };


       let sequenceWidth = measureBaseWidth();


       while (sequenceWidth < minimumSequenceWidth && safety < 12) {
         originals.forEach((slide) => {
           const filler = makeGeneratedClone(slide);
           filler.dataset.tbxBaseFiller = 'true';
           track.appendChild(filler);
           baseSlides.push(filler);
         });


         sequenceWidth = measureBaseWidth();
         safety += 1;
       }


       const secondSequence = baseSlides.map((slide) => {
         const clone = makeGeneratedClone(slide);
         clone.dataset.tbxLoopCopy = 'true';
         track.appendChild(clone);
         return clone;
       });


       const firstBaseSlide = baseSlides[0];
       const firstSecondSlide = secondSequence[0];


       loopWidth = firstBaseSlide && firstSecondSlide
         ? firstSecondSlide.offsetLeft - firstBaseSlide.offsetLeft
         : sequenceWidth;


       step = getStep(track, originals[0]);
       pixelsPerMillisecond = step / (getSecondsPerCard() * 1000);


       const firstSlideWidth = originals[0]?.getBoundingClientRect().width || 0;
       const mobileCenterOffset = mobileQuery.matches
         ? Math.max(0, (viewport.clientWidth - firstSlideWidth) / 2)
         : 0;


       offset = -loopWidth + mobileCenterOffset;
       currentDot = -1;


       dots = [];


       if (dotsContainer) {
         dotsContainer.innerHTML = '';
         dotsContainer.hidden = true;
       }


       if (previousButton) previousButton.hidden = true;
       if (nextButton) nextButton.hidden = true;


       applyTransform();
       initEqualScrollbars(track);
       startAutoplay();
     }


     root.addEventListener('mouseenter', () => pause('hover'));
     root.addEventListener('mouseleave', () => resume('hover'));
     root.addEventListener('focusin', () => pause('focus'));
     root.addEventListener('focusout', (event) => {
       if (!root.contains(event.relatedTarget)) resume('focus');
     });


     viewport?.addEventListener('pointerdown', (event) => {
       if (event.pointerType === 'mouse' && event.button !== 0) return;
       if (transitionFrameId !== null) stopTransition();


       isDragging = true;
       activePointerId = event.pointerId;
       pointerStartX = event.clientX;
       pointerStartOffset = offset;


       viewport.classList.add('is-dragging');
       track.classList.add('is-dragging');
       viewport.setPointerCapture?.(activePointerId);
       pause('drag');


       if (event.pointerType === 'mouse') event.preventDefault();
     });


     viewport?.addEventListener('pointermove', (event) => {
       if (!isDragging || event.pointerId !== activePointerId) return;


       const deltaX = event.clientX - pointerStartX;
       offset = normalizeOffset(pointerStartOffset + deltaX);
       applyTransform();
     });


     const finishDrag = (event) => {
       if (!isDragging) return;
       if (event?.pointerId !== undefined && event.pointerId !== activePointerId) return;


       isDragging = false;
       viewport.classList.remove('is-dragging');
       track.classList.remove('is-dragging');


       if (
         activePointerId !== null &&
         viewport.hasPointerCapture?.(activePointerId)
       ) {
         viewport.releasePointerCapture(activePointerId);
       }


       activePointerId = null;
       pauseReasons.delete('drag');
       resumeAfterInteraction('drag', 1200);
     };


     viewport?.addEventListener('pointerup', finishDrag);
     viewport?.addEventListener('pointercancel', finishDrag);
     viewport?.addEventListener('lostpointercapture', finishDrag);


     viewport?.addEventListener('wheel', (event) => {
       const horizontalDelta = Math.abs(event.deltaX) > Math.abs(event.deltaY)
         ? event.deltaX
         : (event.shiftKey ? event.deltaY : 0);


       if (!horizontalDelta) return;


       event.preventDefault();
       pause('wheel');
       offset = normalizeOffset(offset - horizontalDelta);
       applyTransform();
       resumeAfterInteraction('wheel', 900);
     }, { passive: false });


     const handleModeChange = () => {
       window.clearTimeout(resizeTimer);
       resizeTimer = window.setTimeout(prepareLoop, 80);
     };


     mobileQuery.addEventListener?.('change', handleModeChange);


     const resizeObserver = new ResizeObserver(() => {
       window.clearTimeout(resizeTimer);
       resizeTimer = window.setTimeout(prepareLoop, 120);
     });


     if (viewport) resizeObserver.observe(viewport);


     root._tbxDestroy = () => {
       destroyed = true;
       stopAutoplayMotion();
       stopTransition();
       resizeObserver.disconnect();
       mobileQuery.removeEventListener?.('change', handleModeChange);
       window.clearTimeout(resizeTimer);
       window.clearTimeout(interactionResumeTimer);
       destroyEqualScrollbars(track);
       clearGeneratedClones();
       root.dataset.carouselReady = 'false';
     };


     prepareLoop();
   }


   function initManual(section) {
     const root = section.querySelector('.ptribex-trust__slider');
     const track = root?.querySelector('.ptribex-trust__track');
     const slides = track
       ? Array.from(track.children).filter((item) => item.classList.contains('ptribex-trust__card'))
       : [];
     const dots = section.querySelector('.ptribex-trust__dots:not(.ptribex-trust__dots--dynamic)');


     initContinuousCarousel(section, root, track, slides, dots);
   }


   function initJudgeMe(section) {
     const widget = section.querySelector('.ptribex-trust__judgeme-host');
     const dynamicRoot = section.querySelector('.ptribex-trust__dynamic-slider');
     const dynamicTrack = section.querySelector('.ptribex-trust__track--dynamic');
     const dots = section.querySelector('.ptribex-trust__dots--dynamic');


     if (!widget || !dynamicRoot || !dynamicTrack) return;


     const buildFromReviews = () => {
       removeVerifiedBuyer(widget);


       const reviewList = widget.querySelector('.jdgm-rev-widg__reviews');
       const reviews = Array.from(widget.querySelectorAll('.jdgm-rev'));


       if (!reviews.length) return false;


       const signature = reviews
         .map((review) => review.textContent.replace(/\s+/g, ' ').trim())
         .join('|');


       if (
         dynamicTrack.dataset.signature === signature &&
         dynamicRoot.dataset.carouselReady === 'true'
       ) {
         return true;
       }


       dynamicRoot._tbxDestroy?.();
       dynamicTrack.dataset.signature = signature;
       dynamicTrack.innerHTML = '';


       reviews.forEach((review) => {
         const clone = review.cloneNode(true);
         removeDuplicateIds(clone);
         removeVerifiedBuyer(clone);
         dynamicTrack.appendChild(clone);
       });


       if (reviewList) reviewList.style.display = 'none';


       dynamicRoot.hidden = false;
       dynamicRoot.dataset.carouselReady = 'false';


       const slides = Array.from(dynamicTrack.children);
       initContinuousCarousel(section, dynamicRoot, dynamicTrack, slides, dots);
       return true;
     };


     if (buildFromReviews()) return;


     const observer = new MutationObserver(() => {
       removeVerifiedBuyer(widget);
       if (buildFromReviews()) observer.disconnect();
     });


     observer.observe(widget, { childList: true, subtree: true });
     window.setTimeout(() => observer.disconnect(), 12000);
   }


   function initSection(section) {
     if (!section || section.dataset.initialized === 'true') return;


     section.dataset.initialized = 'true';


     if (section.dataset.useJudgeme === 'true') {
       initJudgeMe(section);
     } else {
       initManual(section);
     }
   }


   function initAll(root = document) {
     root.querySelectorAll(SELECTOR).forEach(initSection);
   }


   if (document.readyState === 'loading') {
     document.addEventListener('DOMContentLoaded', () => initAll());
   } else {
     initAll();
   }


   document.addEventListener('shopify:section:load', (event) => {
     initAll(event.target);
   });


   document.addEventListener('shopify:section:unload', (event) => {
     event.target.querySelectorAll(SELECTOR).forEach((section) => {
       section
         .querySelectorAll('.ptribex-trust__slider, .ptribex-trust__dynamic-slider')
         .forEach((root) => root._tbxDestroy?.());
     });
   });
 })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-promise"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindSection(section) {
      if (!section || section.dataset.qualityPromiseFactsBound === 'true') return;
      var openBtn = section.querySelector('.js-quality-promise-facts-open');
      var dialog = section.querySelector('.js-quality-promise-facts-dialog');
      if (!openBtn || !dialog || typeof dialog.showModal !== 'function') return;

      section.dataset.qualityPromiseFactsBound = 'true';

      openBtn.addEventListener('click', function () {
        dialog.showModal();
      });

      section.querySelectorAll('.js-quality-promise-facts-close').forEach(function (btn) {
        btn.addEventListener('click', function () {
          dialog.close();
        });
      });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) {
          dialog.close();
        }
      });
    }

    function bindAll(root) {
      var scope = root || document;
      var list = scope.querySelectorAll ? scope.querySelectorAll('.quality-promise') : [];
      if (scope.classList && scope.classList.contains('quality-promise')) {
        bindSection(scope);
        return;
      }
      list.forEach(bindSection);
      if (!list.length && scope.querySelector) {
        var inner = scope.querySelector('.quality-promise');
        if (inner) bindSection(inner);
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      bindAll(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      bindAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
